import { Component, OnInit } from '@angular/core';
import { E5coreUiSearchResultsBaseComponent } from './e5core-ui-search-results-base';

@Component({
  selector: 'e5core-ui-search-results-box',
  templateUrl: './e5core-ui-search-results-box.component.html',
  styleUrls: ['./e5core-ui-search-results-box.component.css']
})
export class E5coreUiSearchResultsBoxComponent extends E5coreUiSearchResultsBaseComponent implements OnInit {

  ngOnInit() {
  }

}
